import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallTransferStarted } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { getTransferTargetName } from 'entities/Call/lib/transferTarget'

export const useEventCallTransferStarted = () => {
  const { websocket, inboxesStore } = useEntitiesContext()

  const handle = (data: IResponseCallTransferStarted) => {
    const target = getTransferTargetName(data, inboxesStore)

    toastStore.add({
      type: 'info',
      title: `Transferring to ${target}...`,
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.CallCallTransferStarted, handle), [])
}
